module.exports = __webpack_public_path__ + "static/media/hm8.6e017de0.PNG";